import { CatSkeleton } from 'components/blocks-components';
import styles from '../selected-equipment/selected-equipment.module.scss';
import { MyEquipmentHeader } from '../my-equipment-header';
import { useCallback } from 'react';

export const MyEquipmentLoader = () => {
  const getSkeletonLoader = useCallback((heightInPx) => {
    return (
      <div className="overflow-hidden" style={{ height: `${heightInPx}px` }}>
        <CatSkeleton size="xxl" />
      </div>
    );
  }, []);
  return (
    <>
      <div className="d-blg-none d-md-block">
        <div className="d-flex justify-content-between mb-2 mt-2 mx-1">
          <div className="d-block d-blg-none">
            <MyEquipmentHeader />
          </div>
          <CatSkeleton width="108px" />
        </div>
        <div className={styles['loader-wrapper']}>
          <div
            className={`${styles['equipment-loader-wrapper']} d-blg-none p-3 p-md-4 `}
          >
            <div className={styles['loader-container']}>
              <div className={styles['equipment-name-loader']}>
                <CatSkeleton size="xxl" />
              </div>
            </div>
            <div className="px-2 mx-1 px-md-0 mx-md-0 pe-md-3 d-block overflow-hidden">
              <div className="col-12 col-sm-10">
                <div
                  className={`${styles['equipment-name-loader-wrapper']} mb-md-2 col-md-10 `}
                >
                  <CatSkeleton size="xxl" />
                </div>
                <div
                  className={`${styles['serial-number-loader-wrapper']} mb-md-2 col-md-8 `}
                >
                  <CatSkeleton size="xxl" />
                </div>
                <div
                  className={`${styles['serial-number-loader-wrapper']} mb-md-3 col-md-8 `}
                >
                  <CatSkeleton size="xxl" />
                </div>
              </div>
              <div
                className={`${styles['equipment-loader-wrapper']} col-5 d-none d-md-block `}
              >
                {getSkeletonLoader(32)}
              </div>
            </div>
            <div className={styles['shop-parts-button-loader']}>
              <div className="w-100 pt-3">{getSkeletonLoader(32)}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="d-none d-blg-block">
        <div className="m-3 p-2 d-flex">
          <div className="col-6 me-2 pe-3">
            <div
              className={`${styles['image-loader']} mb-3 pb-2 overflow-hidden`}
            >
              <CatSkeleton size="xxl" />
            </div>
            <div
              className={`${styles['image-loader-wrapper']} pb-5 overflow-hidden`}
            >
              <CatSkeleton size="xxl" />
            </div>
          </div>
          <div className="col-6 pe-2">
            <div className="row no-gutters">
              <div className="d-inline-flex justify-content-between col-12 mb-3 pb-1">
                <div className="col-4">{getSkeletonLoader(19)}</div>
                <div className="col-2">{getSkeletonLoader(16)}</div>
              </div>
            </div>
            <div className="row no-gutters">
              <div className="d-inline-flex justify-content-between col-12 mb-3 pb-1">
                <div className="col-7">{getSkeletonLoader(40)}</div>
                <div className="col-4">{getSkeletonLoader(40)}</div>
              </div>
            </div>
            {getSkeletonLoader(86)}
          </div>
        </div>
      </div>
    </>
  );
};
